var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:{ disabled: _setup.loading },attrs:{"disabled":_setup.loading},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _setup.handleClick($event, _vm.$listeners)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }